export const en = {
  LANGUAGES: {
    TITLE: 'Languages',
    English: 'English',
    Russian: 'Russian',
    Ukrainian: 'Ukrainian',
    German: 'German',
  },
  PAGES: {
    CHAT_HISTORY: {
      YOUR_PREVIOUS_CONVERSATION: 'Your previous chats',
      SEARCH_BY_NAME: 'Search by name',
      PLACEHOLDER_TITLE: 'No results found for your query',
      PLACEHOLDER_TEXT: 'Try changing your search parameters',
      EMPTY: {
        TITLE: 'You have no active chats yet',
        TEXT: 'Choose an adventure from tens of thousands or create your own',
        CREATE_CHATBOT: 'Create a chatbot',
        GO_TO_CATALOG: 'Go to the catalog',
      },
    },
    SUBSCRIBE: {
      SUBSCRIBE: 'Subscribe',
      PICK_THE_PLAN: 'Pick the plan or buy tokens',
      UPGRADE_YOUR_EXPERIENCE: 'Upgrade your experience and unlock your imagination with premium features',
      BUY_TOKENS: 'Buy tokens',
      APPLY: 'Apply',
      PROMOTIONAL_CODE: 'Promotional code',
      COMPARE_CAICHAT_FEATURE: 'Compare CAICHAT features side-by-side',
      NO_ADS: 'No ads',
      SKIP_QUEUES: 'Skip queues',
      CONTEXTUAL_MEMORY_4K: 'Contextual memory up to 4K tokens (approximately 42 messages)',
      ACCESS_MEMORY_MANAGER: 'Access to memory manager',
      CUSTOM_PERSONAS_10: 'Up to 10 custom personas',
      CONTEXTUAL_MEMORY_8K: 'Contextual memory up to 8K tokens (approximately 84 messages)',
      SEMANTIC_MEMORY_2: 'Semantic memory 2.0: automatic saving and use of memories',
      EXTENDED_RESPONSES: 'Extended responses up to 300 tokens',
      IMAGE_GENERATION: 'Image generation in conversation',
      ACCESS_AI_MODELS: 'Access to additional AI models',
      CUSTOM_PERSONAS_50: 'Up to 50 custom personas',
      CONTEXTUAL_MEMORY_16K: 'Contextual memory up to 16K tokens (approximately 168 messages)',
      PRIORITY_GENERATION: 'Priority in response generation',
      ACCESS_ADVANCED_MODELS: 'Access to advanced AI models',
      IMAGE_GENERATION_ALL: 'Image generation for all characters, including private ones',
      TEXT_TO_SPEECH: 'Text-to-Speech feature (voice responses)',
      CUSTOM_PERSONAS_100: 'Up to 100 custom personas',
    },
    MY_PROFILE: {
      MY_PROFILE: 'My profile',
      SETTINGS: 'Settings',
      LOG_OUT: 'Log Out',
      TITLE: 'Hold Tight!\nYour Personal Dashboard is Cooking!',
      TEXT: "Our team is working hard to bring you a super-convenient personal account.\nSoon, you'll be able to view detailed statistics, track expenses and revenue, and much more.\nStay tuned!",
      TABS: {
        REFERRAL: 'Referral',
        MONETIZATION: 'Monetization',
        PURCHASE_HISTORY: 'Purchase History',
        BALANCE_HISTORY: 'Balance History',
        AI_MODELS: 'AI Models',
      },
    },
    MY_PERSONAS: {
      PLACEHOLDER_1: 'You don`t have any Personas yet.',
      PLACEHOLDER_2: 'Create a new one.',
      CREATE_PERSONA: 'Create new Persona',
    },
    CREATE_PERSONA: {
      PERSONA: 'Persona',
      NAME_PLACEHOLDER: "Enter your Persona's name",
      DESCRIPTION: 'Description',
      DESCRIPTION_PLACEHOLDER: 'How would your Persona describe themselves?',
      DESCRIPTION_INFO: 'Used only in your conversations to help the AI with context. Keep it short (1-2 sentences).',
      VISIBILITY: 'Visibility',
      PUBLIC: 'Public',
      PRIVATE: 'Private',
      CHECKBOX: 'Set as default Persona',
      ALREADY_DEFAULT: 'Already default Persona',
      NAME: 'Name',
      SUCCESSFULLY_CREATED: 'Persona successfully created',
      SUCCESSFULLY_UPDATED: 'Persona successfully updated',
      NO_SPACE_FOR_NEW_PERSONAS: 'You cannot create new Personas until you free up space',
    },
    MY_CHATBOTS: {
      NO_CHATBOTS: 'You haven`t created any chatbots yet!',
      DO_IT_NOW: 'Do it right now!',
    },
    CHARACTERS: {
      NO_CHARACTERS: 'No results found for your query',
      FILTERS: 'Try changing your search parameters or create your own chatbot',
    },
    PUBLIC_PROFILE: {
      NO_CHATBOTS: 'This user currently has no chatbots',
      TRY_LATTER: 'Try coming back another time',
    },
    FAVORITES: {
      NO_FAVORITES: 'You currently have no chatbots in your favorites',
      GO_AND_ADD: 'Go to the catalog and add chatbots to your favorites by clicking the button',
    },
    CHATBOT_CREATE: {
      UPLOADING: 'Uploading',
      MODEL_AND_PROMPT: 'Choose the AI model and its behavior',
      IMPORT_CHATBOT: 'Import chatbot',
      CHATBOT_AVATAR: 'Chatbot avatar',
      CHATBOT_NAME: 'Chatbot name',
      CHATBOT_DESCRIPTION: 'Chatbot description',
      UPLOAD_IMAGE_FOR_CHATBOT: 'Upload image for chatbot',
      CREATE_CHATBOT: 'Create chatbot',
      START_CHAT: 'Start chat',
      SAVE_CHANGES: 'Save changes',
      AGREEMENT_TEXT: 'I have read and agree with the',
      COMMUNITY_GUIDELINES: 'Community Guidelines',
      MESSAGE_COST: 'Message cost',
      GENDER: 'Gender',
      VISIBILITY: 'Visibility',
      ADD_TAGS: 'Add tags',
      SEARCH_TAGS: 'Search tags',
      NAME_PLACEHOLDER: 'Enter chatbot name',
      DESCRIPTION_PLACEHOLDER: 'A short chatbot description shown in the catalog and preview.<br><br>Does not affect memory or behavior.',
      CREATE_NEW_CHATBOT: 'Create new chatbot',
      EDIT_CHATBOT: 'Edit chatbot',
      CHATBOT_PROFILE: 'Chatbot Profile',
      GUIDE: 'Read Guide',
      READ_CREATION_GUIDE: 'Read our chatbot creation guide',
      STATS_TITLE: 'Stats',
      HAS_BEEN_STARTED: 'Start Date:',
      USER_MESSAGES: 'User messages:',
      CHARACTER_MESSAGES: 'Chatbot messages:',
      USER_WORDS: 'User words:',
      CHARACTER_WORDS: 'Chatbot words:',
      FILL_REQUIRED_FIELDS: 'It is necessary to fill in the required fields!',
      MALE: 'Male',
      FEMALE: 'Female',
      NON_BINARY: 'Non-binary',
      OTHER: 'Other',
      NOT_SPECIFIED: 'Not specified',
      PUBLIC: 'Public',
      PRIVATE: 'Private',
      BY_LINK: 'Private By Link',
      VISIBLE_TOOLTIP: 'Public - visible to all. Private - only visible to the author this chatbot.',
      AI_TOOLTIP:
        'AI model: a program trained to understand and generate text like a human.\n\nBehavior: the narrative style and guidance that tells the AI how it should behave.',
      NO_ONLY_EMOJI: 'Name cannot consist only of emojis',
      COST_DEPENDS: 'The cost depends on various parameters: Model, nBehavior, Greetings, Scenario.',
      PRICE_1_MESSAGE: 'Price for 1 message:',
      NOT_AVAILABLE: {
        TITLE: 'This is private chatbot',
        TEXT: 'You are trying to access a link to a chatbot that is restricted by its author. You cannot view or interact whit this chatbot.',
        GO_HOME: 'Go to Homepage',
      },
      OTHER_CHATBOTS_BY_AUTHOR: 'Other bots from this author',
      SIMILAR_CHATBOTS: 'Similar bots',
      ACCESS_ONLY_LINK: "Access to it is only available\n through the author's link.",
      PERSONAL_CHARACTER: 'This is personal character',
      DEFINITION: 'Definition',
      ALLOW_PROXIES: 'Allow Proxies',
      DEFINITION_DESCRIPTION: "Users will be able to see chatbot's personality, scenario, and dialogs.",
      ALLOW_PROXIES_DESCRIPTION: 'Users will be able to use proxy services to interact with your bot.',
      ADDITIONAL_SETTINGS: 'Additional settings',
      SETTINGS: 'Settings',
      ALLOW_REPLACEMENT: 'User models',
      ALLOW_REPLACEMENT_DESCRIPTION: 'Users will be able to use personal models to communicate with the bot.',
      SHOW_NOTES_FIRST: 'Show first',
      SHOW_NOTES_FIRST_DESCRIPTION: 'When viewing the chatbot, users will first see your Author’s notes, and only then the first message.',
      EDIT: 'Edit chatbot',
    },
  },
  MODALS: {
    UPGRADE_SUGGESTION: {
      BANNER: 'HURRY!',
      TITLE:
        'Save <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent">{{percent}}%</span> on Endless Stories',
      TEXT: 'Unlock smarter memory, image generation, and deeper conversations',
      PER_YEAR: '/yr',
      PER_MONTH: '/m',
      ENHANCED_MEMORY_TITLE: 'Enhanced Memory',
      ENHANCED_MEMORY_DESCRIPTION: 'Your story stays intact, start to finish',
      UNLIMITED_IMAGE_GENERATION_TITLE: 'Unlimited Image Generation',
      UNLIMITED_IMAGE_GENERATION_DESCRIPTION: 'Generate scenes and characters without limits',
      RICHER_ROLEPLAY_TITLE: 'Richer Roleplay',
      RICHER_ROLEPLAY_DESCRIPTION: 'Deeper stories, more expressive characters',
      UNLOCK: 'UNLOCK MY STORY - UP TO {{percent}}% OFF',
      UNLOCK_MOBILE: 'UNLOCK MY STORY - UP TO {{percent}}%',
      MAYBE_LATER: 'Maybe later',
    },
    MODEL_SETTINGS: {
      TITLE: 'Model settings',
      ADVANCED_SETTINGS: 'Advanced Settings',
      APPLY_SETTINGS: 'Apply Settings',
    },
    GENERATE_IMAGE: {
      GENERATE_BACKGROUND: 'Generate background',
      GENERATE_AVATAR: 'Generate avatar',
      GENERATE_IMAGE: 'Generate image',
      ENTER_PROMPT: 'Describe the image to generate',
      AGE_ERROR: 'Request rejected: safety moderation. Characters under 18 not allowed.',
      PROMPT_PLACEHOLDER: 'Select the generation model and describe the image',
    },
    CHATBOT_REMOVED: {
      TITLE: 'Chatbot removed',
      TEXT: 'This chatbot has been removed by the author or administrator. Start chatting with other bots right now.',
      GO_HOME: 'Go to Homepage',
    },
    WELCOME: {
      TITLE: 'Welcome',
      CAN_CHANGE: 'You can change this at any time',
      AGE_AGREE: 'I confirm that I am 18 years or older',
      BOUND_BY: 'You agree to be bound by our',
    },
    GUIDELINES: {
      TITLE: 'Community Guidelines Agreement',
      TEXT_1:
        'To ensure a positive and respectful experience for everyone, we ask that you adhere to our community guidelines which includes namely:',
      TEXT_2: 'No content involving illegal subjects such as incest, underage individuals, or any illegal activity.',
      TEXT_3: 'Respect others and promote a safe space for diverse discussions.',
      TEXT_4: 'Follow all applicable laws and be considerate of community standards.',
      TEXT_5:
        'By continuing, you agree to follow these guidelines and help maintain a healthy, respectful environment. Let’s keep it fun and respectful for everyone!',
      I_HAVE: 'I have read and will follow the',
      START_CHATTING: 'Start Chatting',
    },
    ALLOW_NSFW_CONTENT: {
      TITLE: 'NSFW Content Access',
      TEXT: 'Visibility of the explicit content must be enabled in your account settings. Once enabled, you can manage NSFW content visibility directly from the home page.',
      GO_TO_SETTINGS: 'Go to settings',
    },
    CHAT_DECRYPT: {
      TITLE: 'This chat is password protected',
      TEXT: 'Enter password to access the chat',
      ENCRYPT_PASSWORD: 'Encryption password',
      CONFIRM_ENCRYPT_PASSWORD: 'Confirm encrypt password',
    },
    CHAT_ENCRYPT: {
      TITLE: 'End-to-end encryption',
      NOT_ENCRYPTED: 'Your chat is not encrypted',
      ENCRYPTED: 'Your chat is encrypted',
      TEXT: 'Messages and chats are protected by end-to-end encryption. Third parties, including {{brand}}, cannot read your messages.',
      ENTER_LABEL: 'Create an encryption password if you want to enable encryption for your chat with the chatbot.',
      ENABLE: 'Enable encryption',
      DISABLE: 'Disable encryption',
    },
    CHARACTER_INFO: {
      CHOOSE_A_PERSONA: 'Choose a persona:',
      AI_MODEL_AND_A_SYSTEM_PROMPT: 'AI model and a system prompt',
      TAGS: 'Tags',
      TAGS_PLACEHOLDER: 'Tag your character with relevant keywords (maximum 10 total tags)',
      START_CHAT: 'Start chat',
    },
    PASSWORD_RESET: {
      ENTER_NEW_PASSWORD: 'Enter a new password in the fields below.',
      INVALID_URL: 'Invalid URL. Please request a new password reset.',
      APPLY_NEW_PASSWORD: 'Apply new password',
      REQUEST_PASSWORD_RESET: 'Request password reset',
    },
    IMAGES_GENERATION_SETTINGS: {
      IMAGES_TITLE: 'Images',
      NEGATIVE_PROMPT: 'Negative Prompt',
      NEGATIVE_PROMPT_PLACEHOLDER: 'Please write what you would not like to see in the images',
      STYLE_TITLE: 'Style',
      STYLE_ANIME: 'Anime',
      UNI_STYLE: 'Unistyle',
      STYLE_REALISTIC: 'Realistic',
      GENERATION_OF_NSFW: 'Generation of NSFW images',
      GENERATION_OF_NSFW_TOOLTIP: 'Turn it on if you do want to see content that is not suitable for minors.',
      GUIDANCE_SCORE: 'Guidance Score',
      CREATIVE: 'Creative',
      PRECISE: 'Precise',
      DISABLE: 'Disable',
      ENABLE: 'Enable',
    },
    PROFILE_SETTINGS: {
      MY_ACCOUNT: {
        MY_ACCOUNT: 'My Account',
        CHANGE_PERSONA: 'Change Persona',
        DEFAULT_PERSONA: 'Default Persona',
        USERNAME: {
          USERNAME: 'Username',
          PLACEHOLDER: 'Enter your username',
          ERROR: 'Username must only contain Latin letters (a–z), numbers, and hyphens',
          ERROR_LENGTH: 'Username must be between 3 and 20 characters long.',
        },
        EMAIL: {
          EMAIL: 'Email',
          PLACEHOLDER: 'Enter your email',
          VERIFIED: 'Email verified',
          VERIFY: 'Verify email',
          NOT_VERIFIED: 'Email not verified',
        },
        EMAIL_VERIFICATION: {
          TITLE: 'Email verification',
          TEXT_1: 'An email has been sent to the address',
          TEXT_2: 'Please click the link in that email to complete your verification.',
          NO_CODE: "Didn't receive the code?",
          RESEND: 'Resend again',
          SEC: 'sec',
          ERROR: 'Failed to send verification email. {{error}}',
        },
        DATE_OF_BIRTH: 'Date of birth',
        DATE_OF_BIRTH_ERROR: 'Minimum age should at least be 18 years old',
        DESCRIPTION: 'Description',
        DESCRIPTION_PLACEHOLDER: 'Enter short description here',
        SOCIALS: 'Socials',
        ADD_NEW: 'Add new',
        SAVE: 'Save',
        SUCCESS: 'Data saved successfully!',
        FAIL: `Failed to save data, {{error}}`,
      },
      PREFERENCES: {
        PREFERENCES: 'Preferences',
        THEME: {
          THEME: 'Theme',
          SYSTEM: 'System',
          LIGHT: 'Light',
          DARK: 'Dark',
        },
        NSFW: {
          TITLE: 'Display chatbots with explicit images or languages (NSFW)',
          ERROR: 'You cannot enable NSFW content display. Please confirm that you are 18 years old on the ',
          LINK: 'My Account tab',
        },
        NOTIFICATIONS: {
          SUCCESS: 'Settings were successfully applied!',
          FAIL: 'Failed to apply settings',
        },
      },
      SECURITY: {
        SECURITY: 'Security',
        TWO_FACTOR: {
          TITLE: 'Two-factor authentication',
          DESCRIPTION: 'Two-factor authentication (2FA) provides more reliable account protection.',
          DOWNLOAD: 'Download Google Authenticator',
          APP_DESCRIPTION:
            'Google Authenticator is an independent service from Google Inc. that helps secure your account. Once it is set up, you will need to confirm your login to the app or withdrawals using a password generated by Google Authenticator.',
          SCAN: 'Scan the QR code or download from the app store',
          DOWNLOAD_ON_THE: 'Download on the',
          WORKS_WITH: 'Works with',
          STEP: {
            STEP: 'Step',
            ONE: 'Enter password',
            TWO: 'Download the app',
            THREE: 'Add the key',
            FOUR: 'Enter code',
            FIVE: 'Download codes',
          },
          CONTINUE: 'Continue',
          CONFIRM: 'Confirm',
          ADD_KEY: 'Add the key to Google Authenticator and make a backup',
          ADD_KEY_TIP: 'Open Google Authenticator, scan the QR code or enter the key below to add the confirmation token.',
          SCAN_QR_CODE: 'Scan the QR code or enter the key below in to app',
          CODE_TIP: 'Save your key in case you encounter login issues, such as losing your phone or other problems.',
          ENTER: 'Enter the code from the Google Authenticator app.',
          ENTER_TIP: 'Open the GA app and enter the verification code in the field below.',
          GA_CODE: 'GA Code',
          ENTER_CODE: 'Enter the code',
          CODE_ERROR: 'Invalid code',
          DOWNLOAD_CODES: {
            TITLE: 'Download backup codes',
            TIP: 'Save these backup codes in a safe place. You can use them to access your account if you lose your authenticator device.',
            WARNING: 'Each code can only be used once. Store them securely!',
            BUTTON: 'Download Backup Codes',
          },
          DISABLE: {
            TITLE: 'Disable Two-Factor Authentication',
            TIP: 'Enter your password to disable 2FA. This will make your account less secure.',
            WARNING: 'Disabling 2FA will remove an important security layer from your account',
            BUTTON: 'Disable 2FA',
          },
          ENABLE_SUCCESS: 'Two-factor authentication has been enabled successfully',
          ENABLE_FAIL: 'Failed to enable two-factor authentication',
          DISABLE_SUCCESS: 'Two-factor authentication has been disabled successfully',
          DISABLE_FAIL: 'Failed to disable two-factor authentication',
          ENTER_CODE_FROM_DEVICE: 'For your security, enter the 6-digit code that was generated in the app on your device.',
          VERIFICATION_CODE: 'Verification code',
          TRUST_DEVICE: 'Trust this device for 30 days',
          AUTH_APP: 'Authenticator App',
          BACKUP_CODE: 'Backup Code',
          DISCLAIMER_1: 'This helps protect your account.',
          DISCLAIMER_2: 'Never share your OTP with anyone.',
          ENTER_BACKUP_CODE: 'Enter backup code',
          BACKUP_TIP: 'Use one of your backup codes if you can’t access your authenticator app',
          INVALID_CODE: 'The code you entered seems invalid. Please try another one',
        },
        PASSWORD: {
          TITLE: 'Password',
          AGO: 'Changed',
          CURRENT: 'Current password',
          NEW: 'New password',
          CONFIRM: 'Confirm new password',
          SIGN_OUT: 'Sign out of all active logins',
          SET: 'Set password',
          CHANGE: 'Change password',
          SUCCESS: 'Password has been changed successfully!',
          FAIL: 'Failed to change password, {{error}}',
          PLACEHOLDER: 'Enter password',
          TIP: 'You do not have a password set for logging into the site. To set up two-factor authentication, you need to create a password for your account.',
          CREATE: 'Create password',
        },
        SOCIAL: {
          TITLE: 'Login via social networks',
          DESCRIPTION:
            'Connect your CAICHAT.AI account with your social media accounts for simple and secure sign-in. Social sign-in skips two-step verification and may reduce your account’s security.',
          CONNECT: 'Connect',
          DISCONNECT: 'Disconnect',
          CONNECTED: 'Connected',
          NOT_CONNECTED: 'Not connected',
          NOTIFICATIONS: {
            SUCCESS: 'Successfully disconnected {{providerName}} account',
            FAIL: 'Failed to disconnect account, {{error}}',
          },
        },
      },
    },
    PAYMENTS: {
      TOKENS_TITLE: 'You are purchasing tokens',
      RENEWAL: 'Renewal occurs in {{period}} days for {{price}}/{{period}} days. Cancel anytime.',
      SECURE: 'Payments are secure and encrypted',
      CHANGE: 'Change',
      SUBTOTAL: 'Subtotal',
      DISCOUNT: 'Discount',
      TOTAL: 'Total',
      CONTACT_INFORMATION: 'Contact Information',
      CHOOSE_PAYMENT_METHOD: 'Choose Payment Method',
      TOS_1: 'By clicking the "Continue" button, you confirm that you are 18 years or older, you accept the',
      TOS_2: 'and the',
      TOS_3: '. We care about protecting your privacy, so the charge on your card will appear as "{{ brand }}".',
      TOS_4: 'For any payment inquires, please contact customer support at {{ email }}.',
      TOS_5: "You agree that we will store your personal payment information so you won't have to enter it again in the future.",
      BONUS: 'Bonus',
    },
    DELETE_CHAT: {
      TITLE: 'Delete chat',
      TEXT: 'Are you sure you want to delete this chat? Once deleted, it cannot be recovered.',
      SUCCESS: 'Chat was deleted successfully!',
      FAIL: 'Failed to delete chat!',
    },
    DELETE_PERSONA: {
      TITLE: 'Delete Persona',
      TEXT:
        'Deleting this person will lead to irreversible consequences - it will be impossible to restore it.\n' +
        'The history of communication with bots will remain, and you will be able to continue the conversation, but on behalf of another Persona.\n' +
        '\n',
      SURE: 'Are you sure you want to delete this profile?',
      WARNING: 'The current default persona cannot be deleted.\n' + 'First select another as default or create a new one.',
      SUCCESS: 'Persona was deleted successfully!',
      FAIL: 'Failed to delete persona!',
    },
    DELETE_CHATBOT: {
      TITLE: 'Delete chatbot',
      TEXT_1: 'Deleting the chatbot will also remove all chats and images within them. They cannot be restored.',
      TEXT_2: 'Are you sure you want to delete this chatbot?',
      SUCCESS: 'Chatbot was deleted successfully!',
      FAIL: 'Failed to delete chatbot!',
    },
    BLOCK_CREATOR: {
      TITLE: 'Block this author?',
      TEXT: 'Are you sure you want to block all chatbots from this creator? You can unblock them at any time.',
      BLOCK: 'Block',
    },
    UNBLOCK_CREATOR: {
      TEXT: 'Are you sure to unblock the creator ',
      CANCEL: 'No',
      SUCCESS: 'The creator has been unblocked successfully!',
      FAIL: 'Failed to unblock creator. Please try again later.',
    },
    COMPLAIN: {
      TITLE: 'Complain',
      MAX_CHECKBOXES: 'You can select a maximum of 5 checkboxes',
      DETAILS_PLACEHOLDER: 'Describe what displeased you',
      CHECKBOX: {
        THREATS: 'Threats and harassment',
        CRUELTY: 'Excessive cruelty',
        FALSE: 'False statements',
        HATRED: 'Incitement to hatred',
        NSFW: 'Not safe for work',
        HARASSMENT: 'Sexual harassment',
        CHILD_EXPLOIT: 'Exploitation of children',
        SELF_HARM: 'Self-harm',
        TERRORISM: 'Terrorism and extremism',
        ILLEGAL: 'Illegal activity',
        DRUGS: 'Drug deals',
        CONFIDENTIALITY: 'Breach of confidentiality',
        IMPERSONATION: 'Impersonation',
        SPAM: 'Commercial spam',
      },
    },
    TELL_US_MORE: {
      TITLE: 'Tell Us More',
      ADDITIONAL_DETAILS: 'Additional details',
      DETAILS_PLACEHOLDER: 'Describe what pleased you',
      SUCCESS: 'Your feedback has been submitted successfully!',
      FAIL: 'Failed to submit feedback. Please try again later.',
      FUNNY: 'Funny',
      HEALTHY: 'Healthy',
      FLIRTY: 'Flirty',
      INTERESTING: 'Interesting',
      GOOD_MEMORY: 'Good Memory',
    },
    MODEL_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Model added to favorites successfully',
        FAIL: 'Failed to add to favorites, please try again later.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Model removed from favorites successfully',
        FAIL: 'Failed to remove from favorites, please try again later.',
      },
    },
    PROMPTS_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Narrative style successfully added to favorites',
        FAIL: 'Failed to add to favorites, please try again later.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Narrative style successfully removed from favorites',
        FAIL: 'Failed to remove from favorites, please try again later.',
      },
    },
    MEMORIES: {
      TITLE: 'Memories',
      PLACEHOLDER_1: 'There are no memories here yet.',
      PLACEHOLDER_2: 'Continue chatting with the chatbot or create a new one.',
      INPUT_PLACEHOLDER: 'Add a new memory...',
      SUBTITLE: 'Add memories of your past relationships with the character',
      EDIT: 'Edit memory',
      DELETE: 'Delete memory',
      PIN: 'Pin memory',
      UNPIN: 'Unpin memory',
      PINNED: '(Pinned)',
      EDITED: '(edited)',
      DELETE_TEXT: 'Are you sure you want to delete this memory? Once deleted, it cannot be recovered.',
      MEMORIES_ENABLED: 'Memories enabled successfully!',
      MEMORIES_DISABLED: 'Memories disabled successfully!',
      FAILED_TO_UPDATE: 'Failed to update memory settings!',
    },
    REGISTRATION: {
      TITLE: 'Create your account',
      LOGIN_WITH_EMAIL: 'Login with email',
      CONTINUE: 'Continue',
      HAVE_AN_ACCOUNT: 'Already have an account?',
      DONT_HAVE_AN_ACCOUNT: 'Don’t have an account?',
      YOU_AGREE: 'By signing up, you agree to our',
      TERMS_AND_CONDITIONS: 'Terms & Conditions',
      YOU_HAVE_READ: 'and you have read our',
      PRIVACY_POLICY: 'Privacy Policy',
      FORGOT_PASSWORD: 'Forgot password?',
    },
    PASSWORD_RECOVERY: {
      TITLE: 'Recover Password',
      RECOVERY_LINK: 'A recovery link has been sent to your email. Please check your inbox and click on the link to reset your password.',
      ENTER_EMAIL: "Enter the e-mail address you used to register and we'll send you the instruction",
      RESET_PASSWORD: 'Reset password',
    },
    NONEXISTING: {
      TITLE: 'Oops... ',
      TEXT: 'What you are looking for may be located elsewhere or simply does not exist. Please try again.',
    },
    CHOOSE_PERSONA: {
      TITLE: 'Choose Persona',
      SUBTITLE: 'Changing the persona during a conversation can disrupt the narrative flow.',
      SUCCESS: 'Persona was successfully changed!',
      FAIL: 'Failed to change persona!',
    },
    IMPORT_CHATBOT: {
      TITLE: 'Import chatbot',
      DESCRIPTION: 'We currently support importing characters from spicychat.ai and juicychat.ai.',
      IMPORT_FROM_FILE: {
        TITLE: 'Import by JSON or card image ',
        DESCRIPTION: 'Upload character JSON file or an image with embedded character data.',
        SUPPORTED_LABEL: 'Supported formats:',
        SUPPORTED_FORMATS: 'JSON, PNG, JPG',
        CLICK: 'Click to choose or drop file here',
      },
      IMPORT_FROM_URL: {
        TITLE: 'Import by URL',
        ENTER: 'Enter a URL from a supported websites',
        CHATBOT_URL: 'Chatbot URL',
        IMPORT_FROM_URL: 'Import From URL',
      },
    },
    BOOSTY_PAYMENT_STATUS: {
      LINK_ACCOUNT: 'Link your Boosty account',
      ENTER_EMAIL_DESCRIPTION: 'To pay for your Boosty subscription, please enter the Email linked to your Boosty account below',
      EMAIL_WARNING: 'Attention! The Email is linked to your CAICHAT account and cannot be changed',
      EMAIL_LABEL: 'Email linked to Boosty',
      EMAIL_PLACEHOLDER: 'Enter your Email',
      WHERE_FIND_EMAIL: 'Where can I find my email information on Boosty?',
      INSTRUCTION_STEP_1: "Click on your avatar and select 'Account settings' from the dropdown menu",
      INSTRUCTION_STEP_2: "On the 'Profile' tab, you will find your Email. Just copy it and paste it into the form on this page",
      HAVE_YOU_PAID: 'Have you paid for the subscription?',
      CONFIRM_PAYMENT_DESCRIPTION:
        'If you have paid for the Boosty subscription, please confirm below. We will synchronize the data for verification.',
      SYNC_FAILED:
        'Synchronization failed. Please check if your email is correct and if you have successfully paid for the Boosty subscription.',
      CONTACT_SUPPORT: 'If you have any questions or need to change the specified Email, please contact support.',
      RETURN_TO_BOOSTY: 'Return to payment on Boosty',
      I_HAVE_PAID: 'I have paid',
      SUCCESS_PAYMENT: 'You have successfully paid for the Boosty subscription!',
      CONGRATULATIONS: 'Congratulations! You can now use more features on CAICHAT.AI. Start new chats right now!',
      DATA_SYNCHRONIZED: 'Data synchronized',
      SUBSCRIPTION_VALID_UNTIL: 'Subscription valid until',
      MY_PREVIOUS_CHATS: 'My previous chats',
      GO_TO_HOMEPAGE: 'Go to Homepage',
      SYNCHRONIZING_DATA: 'Synchronizing data',
    },
    TOP_UP: {
      TITLE: 'Top up your token balance',
      NOT_ENOUGH: 'You do not have enough',
      TOKENS: 'tokens to generate images.',
      TOP_UP_AND: 'Top up your balance and',
      GENERATE_AMAZING_PHOTOS: 'generate amazing photos',
      RIGHT_IN_THE_CONVERSATION: 'right in the conversation!',
      BUY_TOKENS: 'Buy tokens',
    },
    PAYMENT_RESULT: {
      PAYMENT_ORDER_DETAILS: 'Payment Order Details',
      ORDER_ID: 'Order ID',
      STATUS: 'Status',
      AMOUNT: 'Amount',
      PURCHASED: 'Purchased',
      PAYMENT_METHOD: 'Payment Method',
      PROVIDER_ORDER_ID: 'Provider Order ID',
      CREATED_AT: 'Created At',
      COMPLETED_AT: 'Completed At',
      STATUSES: {
        COMPLETED: 'Completed',
        FAILED: 'Failed',
        PENDING: 'Pending',
        PROCESSING: 'Processing',
        CANCELLED: 'Cancelled',
        REFUNDED: 'Refunded',
      },
    },
    CREATE_REFERRAL_CAMPAIGN: {
      TITLE: 'Add a new campaign',
      NAME: 'Campaign name',
      NAME_PLACEHOLDER: 'Enter text',
      CODE: 'Your promo code',
      CODE_PLACEHOLDER: 'Create your own code or get a random one',
    },
  },
  BLOCKS: {
    BANNER_MAIN: {
      SLIDE_1: {
        TITLE: 'Longer Stories. Richer Worlds.',
        TEXT: 'Characters that remembers everything - so you never have to repeat yourself.',
        BUTTON: 'Upgrade Memory',
      },
      SLIDE_2: {
        TITLE: 'The Full Experience',
        TEXT: 'Premium models, unlimited images, full voice. Your companion come alive.',
        BUTTON: 'Get Everything',
      },
      SLIDE_3: {
        TITLE: 'Next-Level Storytelling',
        TEXT: 'Smarter responses, richer scenes, and characters who actually play along.',
        BUTTON: 'Unlock Full Power',
      },
      SLIDE_NOT_AUTH: {
        TITLE: 'Free Uncensored AI Roleplay',
        TEXT: 'Thousands of unique characters. Infinite stories. Your to explore.',
        BUTTON: 'Get Started Free',
      },
    },
    SORT: {
      MOST_CHATS: 'Most chats',
      NEWEST: 'Newest',
      OLDEST: 'Oldest',
      MOST_POPULAR: 'Most popular',
      MOST_LIKED: 'Most liked',
    },
    LEFT_SIDEBAR: {
      HOME: 'Home',
      CHATS: 'Chats',
      MY_PERSONAS: 'My Personas',
      CREATE_CHATBOT: 'Create Chatbot',
      MY_CHATBOTS: 'My Chatbots',
      FAVORITES: 'Favorites',
      BLOCKED_CREATORS: 'Blocked Creators',
      SUBSCRIBE: 'Subscribe',
      NOTIFICATIONS: 'Notifications',
      HELP: 'Help',
      UPGRADE: 'Upgrade',
    },
    RIGHT_SIDEBAR: {
      UPGRADE_PLAN: 'Upgrade plan',
      GET_PLAN: 'Upgrade subscription',
      FREE: 'FREE plan',
      ACTIVE: 'Active',
      DREAMER: 'Dreamer',
      EXPLORER: 'Explorer',
      STORY_GOD: 'Story GOD',
      NEW_CHAT: 'New chat',
      EXTENSIONS: 'Extensions',
      CREATE_PRESET: 'Create preset',
      PERSONAS: 'Personas',
      VOICES: 'Voices',
      BACKGROUNDS: 'Backgrounds',
      RECENT: 'Recently used AI models',
      PROMPT: 'Behavior',
      NO_MODEL_SELECTED: 'No model selected to continue the chat',
      SELECT_MODEL_PROMPT: 'Select a model and behavior',
      SELECT_MODEL: 'Select AI Model',
    },
    CATALOG_FILTER_PANEL: {
      RESET_FILTER: 'Reset the filter',
      SEARCH_TAGS: 'Search tags',
      SHOW: 'Show',
      CHATBOTS: 'chatbots',
    },
    SAFE_SEARCH_TOGGLE: {
      SAFE_SEARCH: 'Safe search',
    },
    CHATBOT_INFO: {
      TYPE_GREETING_NAME: 'Type greeting name',
      ADD_NEW_GREETING: 'Add new Greeting',
      GREETINGS: 'First Message',
      PERSONALITY: 'Personality',
      SCENARIO: 'Scenario',
      DIALOG: 'Dialog',
      NOTES: "Author's note",
      DESCRIPTION: 'Description',
      AVATAR: 'Avatar',
      NAME: 'Name',
      GREETINGS_PLACEHOLDER:
        'For example: A renowned archaeologist with a mysterious past, Elara Nightshade has spent decades exploring forgotten temples and ancient ruins across the world. With her signature silver-streaked black hair and penetrating amber eyes, she commands respect in academic circles while maintaining an air of enigma.',
      PERSONALITY_PLACEHOLDER:
        "Describe the character's personality, traits, background, speaking style, etc. Use clear, concise language. Examples: 'witty and sarcastic', 'always speaks in rhymes', 'has a phobia of spiders', 'a former detective haunted by a past case.'",
      SCENARIO_PLACEHOLDER: 'Describe the scenario for the character. Use clear, concise language.',
      DIALOG_PLACEHOLDER:
        "Provide an example dialogue showing how the character speaks. Use format like 'User: Hello there\nCharacter: [character's response]'. Include multiple exchanges to demonstrate the character's communication style.",
      NOTES_PLACEHOLDER: 'Write a short explanation for users on how best to interact with this bot',
      CHAT_BACKGROUND: 'Chat Background',
      DELETE_CHAT_BACKGROUND: 'Delete chat background',
      HIDE_THIS_BLOCK: 'Hide this block',
    },
    TOKENIZATOR: {
      TOKENS: 'tokens',
    },
    BLOCK_BUTTON: {
      NO_BLOCKED: 'You have no blocked creators',
      SHARE: 'Share',
      DELETE_CHATBOT: 'Delete this chatbot',
      EDIT: 'Edit',
      BLOCK_CREATOR: 'Block creator',
      UNBLOCK_CREATOR: 'Unblock',
      REPORT: 'Report',
      REPORT_CHATBOT: 'Report chatbot',
      DELETE_IMAGE: 'Delete image',
      VOICE_OVER: 'Voice over',
      REGENERATE_MESSAGE: 'Regenerate message',
      NEW_CHAT_FROM_HERE: 'New chat from here',
      BLOCK_SUCCESS: 'User has been successfully blocked',
      BLOCK_ERROR: 'Failed to block user. Please try again later.',
      UNBLOCK_SUCCESS: 'User has been successfully unblocked',
      UNBLOCK_ERROR: 'Failed to unblock user. Please try again later.',
      IMAGE_SETTINGS: 'Image settings',
      RATE_MESSAGE: 'Rate message',
    },
    CHAT_INPUT: {
      ACTION: 'Action',
      TYPE_YOUR_MESSAGE: 'Type your message...',
      EDIT_MESSAGE_PLACEHOLDER: 'Edit message...',
      DELETED_PERSONA_PLACEHOLDER: 'Your persona has been deleted. Please select another one.',
      DELETED_PRESET_PLACEHOLDER: 'Model unavailable. Please choose another one.',
      SUBSCRIBE_PLACEHOLDER: 'The selected AI model is not available with the current subscription.',
      SELECT_PERSONA: 'Select a persona',
      CHANGE_MODEL: 'Change model',
      NO_MORE_TOKENS: `You have run of out of <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M12.4137 5.51725H8.63443L12.1379 0H7.72409L3.58618 8.27588H6.84137L3.58618 16L12.4137 5.51725Z" fill="#ff9f32"/></svg> tokens for this model. Please top up your balance or switch to a different model`,
      LOW_QUALITY_MODEL: 'Low quality model',
    },
    PRICING_CARD_GROUP: {
      WEEKLY: 'Per week',
      MONTHLY: 'Per month',
      YEARLY: 'Per year',
      SUBSCRIBE_PLAN: 'Subscribe plan',
      UP_TO: 'Up to {{percent}}%',
      OFF: '{{percent}}% off',
    },
    PRICING_CARD: {
      MOST_POPULAR: 'Most Popular',
      MY_SUBSCRIPTION: 'My Subscription',
      SUBSCRIBE: 'Subscribe',
      UNSUBSCRIBE: 'Unsubscribe',
      ACTIVE: 'The level above is active',
      IN_ADDITION: 'In addition to the previous levels:',
      WEEKLY: 'week',
      MONTHLY: 'month',
      YEARLY: 'year',
    },
    MY_PROFILE_CARD: {
      DATE_OF_BIRTH: 'Date of birth:',
      REGISTERED: 'Registered:',
      SUBSCRIBERS: 'Subscribers',
      LIKES: 'Likes',
      MY_CHATBOTS: 'My chatbots',
      MY_PUBLIC_PAGE: 'My public page',
      BALANCE: 'Balance:',
      ADD_TOKENS: 'Add Tokens',
    },
    CHAT_HEADER: {
      DISCLAIMER:
        'CAICHAT.AI operates on AI for creative storytelling and role-playing. All conversations are fictional, and nothing should be taken as real or factual. Enjoy responsibly!',
      SHOW_PREVIOUS: 'Show previous',
    },
    OVERLAY_INVITE_CODE: {
      TITLE: 'Your story begins here!',
      SUBTITLE: 'Just one more step to unlock amazing features',
      ENTER_CODE: 'Enter your invitation code',
      INVITE_CODE: 'Invite Code',
      LETS_GO: 'Lets go!',
      NEED_CODE: 'Need an invitation code?',
      JOIN_DISCORD: 'Join Discord for access',
      SIGN_OUT: 'Sign out',
    },
    TOKEN_PACK_CARD: {
      BUY: 'Buy',
      SALE: 'Sale',
    },
    COMPARE_PLANS_TABLE: {
      MOST_POPULAR: 'Most Popular',
      FUNCTION_LIMIT: 'Function/Limit',
      INCLUDED_IN_PLAN: 'Included in the plan',
      NOT_INCLUDED_IN_PLAN: 'Not included in the plan',
      MAIN_FUNCTION: 'MAIN FUNCTION',
      BONUS_FOR_SUB: 'Bonus tokens for subscription (upon renewal)',
      UNLIMITED_MESSAGES: 'Unlimited messages',
      COUPON_MONTH: 'One-time purchase coupon with a 30-day subscription',
      COUPON_YEAR: 'One-time purchase coupon with a yearly subscription',
      USER_IDENTITIES: 'User personas',
      USER_IDENTITIES_TOOLTIP:
        'After your subscription ends, you’ll switch to the Free plan and won’t be able to create new personas until you free up space',
      ABILITY_TO_USE: 'Ability to use your own models',
      ACCESS_OTHER_EXTENSIONS: 'Access to others and default extensions',
      AVAILABLE_CONTEXT_TOKENS: 'Available context tokens',
      AVAILABLE_LLM_TOKENS: 'Available LLM response tokens',
      LIMITATION_ON_MODELS: 'LIMITATION ON MODELS',
      AVAILABLE_CHARACTERS: 'Available characters',
      NO_RESTRICTIONS:
        'No restrictions on the use of Context, LLM Responses, Characters, and system prompts when using your own AI models, except for the limitations in the "Your AI Models" section',
      CREATE_EXTENSIONS: 'Create your own Extensions',
      ADDITIONAL_FEATURES: 'ADDITIONAL FEATURES',
      SYSTEM_PROMPTS: 'System prompts',
      IMAGE_GEN: 'Image generation available for tokens - a certain number of images per day for free',
      AVATAR_GEN_ALL: 'Avatar generation for all characters, including private ones',
      CHAT_ENCRYPTION: 'Chat encryption',
      ACCESS_EXTENSIONS: 'Access to extensions',
      ACCESS_MEMORY_MANAGER: 'Access to memory manager (Memories) with the ability to add your own entries to it',
      SEMANTIC_MEMORY: 'Semantic memory 2.0',
      TTS: 'Text-to-Speech (voicing responses)',
      CREATE_PRIVATE_CHARACTERS: 'Create your own private characters',
      CREATE_PUBLIC_CHARACTERS: 'Create your own public characters',
      AD_FREE: 'Ad-free',
      NO_QUEUE: 'No queue',
      ADDITIONAL_TOOLS: 'Additional tools for creating characters and extensions',
      LIMITED_EDITION_MODEL: 'Limited edition model',
      UP_TO_200: 'up to 200',
      UNLIMITED: 'Unlimited',
      UP_TO_1_PER_DAY: 'Up to 1 for free per day',
      ONLY_YOUR_OWN_AND_FREE: 'Only to your own and free',
      RECOMMENDED_MODELS_WITHOUT_LIMITATIONS: 'Our recommendations without token limitations',
      UP_TO_5_PER_DAY_PLUS_UNLIMITED_FOR_FEE: 'Up to 5 per day + unlimited generation for a fee',
      ONLY_SPEECH: 'Only speech',
      UNLIMITED_LOW_QUALITY: 'Unlimited, Low quality',
      UNLIMITED_MEDIUM_QUALITY: 'Unlimited, Medium quality',
      UNLIMITED_HIGH_QUALITY: 'Unlimited, High quality',
      TEN_PERCENT_DISCOUNT_ONE_WEEK: '10% discount for one week',
      MONTHLY_COUPON_TEN_PERCENT_DISCOUNT: 'Monthly coupon for a 10% discount on tokens for one week',
      TWENTY_PERCENT_DISCOUNT_ONE_WEEK: '20% discount for one week',
      MONTHLY_COUPON_TWENTY_PERCENT_DISCOUNT: 'Monthly coupon for a 20% discount on tokens for one week',
      THE_ENTIRE_ANSWER: 'The entire answer',
      THIRTY_PERCENT_DISCOUNT_ONE_WEEK: '30% discount for one week',
      MONTHLY_COUPON_THIRTY_PERCENT_DISCOUNT: 'Monthly coupon for a 30% discount on tokens for one week',
      AVAILABLE_CHARACTERS_TOOLTIP:
        'Characters with more than 2000 personality tokens and more than 3000 greetings tokens (based on the higher value) cannot use free models.',
      UP_TO_5k_TOKENS: 'Up to 5000 personality tokens',
      UP_TO_5k_TOKENS_ACTIVE: 'Up to 5000 personality tokens + Active tier models',
      UP_TO_5k_TOKENS_DREAMER: 'Up to 5000 personality tokens + Dreamer tier models',
      UP_TO_5k_TOKENS_CREATOR: 'Up to 5000 personality tokens + Creator tier models',
      UP_TO_5k_TOKENS_STORY_GOD: 'Up to 5000 personality tokens + Story GOD tier models',
      ACTIVE: 'Active',
      FREE_PLAN: 'Free plan',
      FREE_MODELS: 'Free models',
      FREE_MODELS_FREE: 'Free models for characters with personality of up to 5000 tokens',
      FREE_MODELS_ACTIVE: 'Free plan models + Active tier models',
      FREE_MODELS_DREAMER: 'Free plan models + Dreamer tier models',
      FREE_MODELS_CREATOR: 'Free plan models + Creator tier models',
      FREE_MODELS_STORY_GOD: 'Free plan models + Story GOD tier models',
    },
    MODEL_PROMPT_PRESET: {
      MODEL: 'Model',
      DEFAULT: 'Default',
      RECOMMENDED: 'Recommended',
      PRESET: 'Preset',
      LAST_USED: 'Last used',
      SUCCESS: 'Settings were successfully applied!',
      ERROR: 'Failed to apply settings!',
      INCOMPATIBLE: 'Incompatible with AI Model',
      WE_RECOMMEND: 'We recommend',
      AUTHORS_CHOICE: 'Author’s choice',
      POPULAR: 'Popular',
      UNSUITABLE_SUBSCRIPTION: 'Your subscription plan is not suitable for this model.',
    },
    PUBLIC_PROFILE_HEADER: {
      SUBSCRIBERS: 'Subscribers',
      LIKES: 'Likes',
      CHATBOTS: 'Chatbots',
      YOU_HAVE_BLOCKED_THIS_AUTHOR: 'You have blocked this author. ',
      UNBLOCK: 'Unblock',
    },
    PROMPTS_BLOCK: {
      REPLACE: 'Replace AI Model',
      SELECT: 'Select AI Model',
    },
    FILE_UPLOAD: {
      UPLOAD: 'Upload',
    },
    SUBSCRIBE_BOOSTY: {
      CAN_SUBSCRIBE: 'You can also subscribe through Boosty, which offers flexible options to meet your needs.',
      HAVE_SUBSCRIBE: 'You have already subscribed through Boosty. Your subscription is valid until:',
      GO_TO_BOOSTY: 'Go to Boosty',
      SUBSCRIBE_TO_BOOSTY: 'Subscribe to Boosty',
      BACKEND_SUCCESSFULLY_NOTIFICATION: 'Boosty email successfully linked to your account',
    },
    TAGS_SELECT: {
      TAGS: 'Tags',
      PLACEHOLDER: 'Tag your character with relevant keywords (maximum 10 total tags)',
      CREATE_NEW: 'Create new - ',
      LIMIT: 'Maximum 10 total tags only',
      CUSTOM_TAG_VALIDATION: 'Custom tags must be between 3 and 20 characters long (alphanumeric only).',
    },
    CHATBOT_PERSONA_SELECTOR: {
      ADD_NEW: 'Add new',
    },
    CHATBOT_PREVIOUS_CHATS: {
      PREVIOUS_CHATS: 'Your previous chats:',
    },
    CHATBOT_INFORMATION_GREETINGS: {
      CHOOSE_FIRST_MESSAGE: 'Choose a first message:',
    },
    CHATBOT_INFORMATION_SCENARIO: {
      RECOMMENDED_LANG: 'For the chatbot to function correctly, it is recommended to fill out in English',
    },
    REFERRAL: {
      MY_REFERRALS: 'My Referrals',
      ACTIVE: 'Active',
      LOST: 'Lost',
      NON_ACTIVE: 'Non active',
      CREATE_NEW_CAMPAIGN: 'Create new campaign',
      NO_CAMPAIGNS: "You don't have any campaigns created.",
      CREATE_FIRST_CAMPAIGN: 'Create your first campaign and start earning',
      CAMPAIGN_NAME: 'Campaign Name',
      REFERRAL_CODE: 'Referral Code',
      ACTIVATIONS: 'Activations',
      REFERRALS: 'Referrals',
      INCOME: 'Income',
    },
    PURCHASE_HISTORY: {
      DOWNLOAD: 'Download CSV',
      CSV: 'CSV',
      NO_HISTORY: 'You currently have no purchase history',
      TIP: 'Subscribe or purchase tokens',
      BUTTON: 'Choose a subscription plan',
      INFO: 'Info',
      NAME: 'Name',
      STATUS: 'Status',
      CREATED_AT: 'Created at',
      AMOUNT: 'Amount',
      METHOD: 'Method',
      MORE: 'More',
      DISPLAY_ROWS: 'Display rows',
      NO_RESULTS: 'No results found for your query',
      NO_RESULTS_TIP: 'Try changing your search parameters',
      START_DATE: 'Start date',
      END_DATE: 'End date',
      FILTER: 'Filter',
      STATUSES: {
        ALL: 'All statuses',
        PENDING: 'Pending',
        PROCESSING: 'Processing',
        COMPLETED: 'Completed',
        FAILED: 'Failed',
        REFUNDED: 'Refunded',
        CANCELLED: 'Cancelled',
      },
    },
    BALANCE_HISTORY: {
      WEEK: 'Last week',
      MONTH: 'Last month',
      SOURCE: 'Source',
      COST_RATIO: 'Cost ratio',
      EXPENSES: 'Expenses',
      NO_RESULT: 'Your balance history is currently empty',
      TIP: 'Data will appear here when you start chatting with bots or generating images.',
      BUTTON: 'Choose a chatbot',
      NO_RESULT_FOR_QUERY: 'No result found for your query',
      TIP_FOR_QUERY: 'Try changing your search parameters',
      SPEND_TYPE: {
        CHAT: 'Chat',
        IMAGE: 'Image',
        CUSTOM_AGENT: 'Custom Agent',
        IMG_PROMPT_TUNER: 'Image Prompt Tuner',
        AGENT: 'Agent',
        LORE_BOOK: 'Lore book',
        MEMORIES: 'Memories',
        SUGGESTION: 'Suggestion',
        IMAGE_PROMPT: 'Image prompt',
        IMAGE_DESCRIPTION: 'Image description',
        AVATAR_NSFW_MODERATION: 'Avatar NSFW moderation',
        CHARACTER_MODERATION: 'Character moderation',
        PROMPT_MODERATION: 'Prompt moderation',
        IMAGE_AGE_MODERATION: 'Image age moderation',
        OTHER: 'Other',
      },
      IN: 'in',
      OUT: 'out',
      IMAGES: 'Images',
      CHATBOT_REMOVED: 'Chatbot removed',
    },
  },
  UTILS: {
    SMART_DATE_FORMAT: {
      JUST_NOW: 'Just now',
      MINUTES_AGO: '{{count}} {{minutes}} ago',
      HOURS_AGO: '{{count}} {{hours}} ago',
      DAYS_AGO: '{{count}} {{days}} ago',
      WEEKS_AGO: '{{count}} {{weeks}} ago',
      MONTHS_AGO: '{{count}} {{months}} ago',
      ONE_MINUTES: 'minute',
      FEW_MINUTES: 'minutes',
      MANY_MINUTES: 'minutes',
      ONE_HOURS: 'hour',
      FEW_HOURS: 'hours',
      MANY_HOURS: 'hours',
      ONE_DAYS: 'day',
      FEW_DAYS: 'days',
      MANY_DAYS: 'days',
      ONE_WEEK: 'week',
      FEW_WEEKS: 'weeks',
      MANY_WEEKS: 'weeks',
      ONE_MONTH: 'month',
      FEW_MONTHS: 'months',
      MANY_MONTHS: 'months',
    },
    SMART_MESSAGE_FORMAT: {
      ONE_MESSAGES: 'message',
      FEW_MESSAGES: 'messages',
      MANY_MESSAGES: 'messages',
    },
    TIME: {
      H: 'h',
      M: 'm',
      S: 's',
    },
  },
  NOTIFICATIONS: {
    CHATBOT_CREATE: {
      SUCCESS: 'Chatbot "{{name}}" created successfully!',
      UPDATE_SUCCESS: 'Chatbot updated successfully!',
      UPDATE_ERROR: 'Chatbot update error!',
      REQUIRED_FIELDS: 'Required fields must be filled out:',
    },
    CHAT_MESSAGE: {
      NEW_CHAT_STARTED: 'A new conversation started from selected message!',
      ERROR: 'An error occurred while processing the request',
      REPORT_MESSAGE_SENT: 'Your report has been submitted',
      ENCRYPTION_SAVE: 'Your encryption settings have been saved successfully.',
      ENCRYPTION_DELETE: 'Encryption has been canceled.',
      ENCRYPTION_LIMIT: 'You’ve hit your encrypted chat limit! Decrypt a few chats or upgrade your plan to keep encrypting new ones.',
      COMPLAIN_WARNING:
        'In encrypted chats, you cannot submit a complaint or rate a response. This is necessary to fully ensure the confidentiality of your correspondence.',
      EMPTY_RESPONSE: 'An error occurred during the request, please try again',
      RETRY: 'Retry',
    },
    TEXT_TO_SPEECH_ERROR:
      'We couldn`t access your microphone. Please check your browser or device permissions to enable it for speech-to-text.',
    PASSWORD_CHANGED: 'Password successfully changed',
    FAILED_TO_LOAD_IMAGE: 'Failed to load image!',
    COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  },
  COMMON: {
    ADD: 'Add',
    OR: 'or',
    AND: 'and',
    BY: 'by',
    EXAMPLE: 'Example',
    FREE: 'FREE',
    CONTINUE: 'Continue',
    CONFIRM: 'Confirm',
    SUBMIT: 'Submit',
    SAVE: 'Save',
    DONE: 'Done',
    REGENERATE: 'Regenerate',
    GENERATE: 'Generate',
    GENERATION: 'Generation...',
    GENERATING: 'Generating',
    REFILL_BALANCE: 'Refill balance',
    DISCOUNT: '{{percent}}% Discount',
    CREATE: 'Create',
    DELETE: 'Delete',
    DELETED: 'Deleted',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    COPY: 'Copy',
    COPIED: 'Copied',
    BACK: 'Back',
    LOG_IN: 'Log in',
    SIGN_IN: 'Sign in',
    SIGN_UP: 'Sign up',
    SIGN_IN_WITH: 'Sign in with {{ provider }}',
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Confirm Password',
    MIN: 'Min',
    MAX: 'Max',
    NOT_AVAILABLE: 'Not Available',
    WARNING: 'Warning',
    INFO: 'Info',
    ERROR: 'Error',
    SUCCESS: 'Success',
    PLACEHOLDER: {
      SEARCH: 'Search...',
    },
    FILE_INPUT: {
      INVALID_FILE_TYPE: 'The file {{fileName}} has an invalid type. Allowed types: {{allowedTypes}}',
      INVALID_FILE_TYPE_SHORT: 'Allowed types: {{allowedTypes}}',
      MAX_FILE_SIZE: 'File {{fileName}} size must be less that {{maxSize}}MB',
      DRAG_AND_DROP_TO_UPLOAD_IMAGE: 'Drag and drop or click to upload image',
      DROP_FILE: 'Drop file here',
      CHOOSE_FILE: 'Choose File',
    },
    ERRORS: {
      INVALID_FIELD: 'Field is invalid',
      FILLED_IN: 'Field must be filled in',
      MIN_LENGTH: 'Minimum length is {{length}} characters',
      MAX_LENGTH: 'Maximum length is {{length}} characters',
      NO_SPACES: 'Field cannot start, end, or contain only spaces',
      INVALID_EMAIL: 'Invalid email',
      INVALID_CURRENT_PASSWORD: 'Current password is invalid',
      INVALID_USERNAME: 'Invalid username',
      INVALID_USERNAME_EXPANDED:
        'Username must be between 3 and 20 characters long and must only contain Latin letters (a–z), numbers, and hyphens',
      DUMB_ERROR: 'Something went wrong',
      PASSWORD_MISMATCH: 'Passwords do not match.',
      INVALID_PASSWORD:
        'Password length must be between {{ minLength }} and {{ maxLength }} characters. Only A-Z, a-z, 0-9 and special symbols are allowed.',
      INVALID_EMAIL_OR_PASSWORD: 'Invalid email or password',
      INVALID_PASS: 'Invalid password',
      FIELD_BETWEEN: 'Length must be between {{minLength}} and {{maxLength}} characters.',
      PASS_MISMATCH: 'Passwords do not match',
      PASS_NOT_CHANGED: 'New password must be different from the old one',
      VALUE_MUST_BE_BETWEEN: 'Value must be between {{min}} and {{max}}',
      LOADING_ERROR: 'Loading error',
      NOT_ENOUGH_TOKENS: "You don't have enough tokens to generate an image. Please add more tokens to your account.",
      NO_ITEMS_AVAILABLE: 'No items available',
    },
    MONTH: {
      JANUARY: 'January',
      FEBRUARY: 'February',
      MARCH: 'March',
      APRIL: 'April',
      MAY: 'May',
      JUNE: 'June',
      JULY: 'July',
      AUGUST: 'August',
      SEPTEMBER: 'September',
      OCTOBER: 'October',
      NOVEMBER: 'November',
      DECEMBER: 'December',
    },
    WEEK: {
      MONDAY: 'Mon',
      TUESDAY: 'Tue',
      WEDNESDAY: 'Wen',
      THURSDAY: 'Thu',
      FRIDAY: 'Fri',
      SATURDAY: 'Sat',
      SUNDAY: 'Sun',
    },
    SHOW: 'Show',
    HIDE: 'Hide',
    DISABLE: 'Disable',
    ENABLE: 'Enable',
    DENY: 'Deny',
    ALLOW: 'Allow',
    MORE: 'More',
    LESS: 'Less',
  },
  FAQ: {
    TOPIC1: {
      QUESTION: 'How does changing subscription plan work?',
      ANSWER:
        'Changing subscription plan is available at any time: When upgrading to a higher tier — activation happens immediately after paying the difference for the remaining time. When downgrading — activation will occur after the current period ends.',
    },
    TOPIC2: {
      QUESTION: 'Does bonus energy expire after subscription ends?',
      ANSWER:
        'No, bonus energy does not expire — you can continue using it even after subscription ends. When you subscribe again, you will receive a new portion of bonus energy.',
    },
    TOPIC3: {
      QUESTION: 'Does subscription renew automatically?',
      ANSWER:
        "Yes, subscription renews automatically for your convenience so you don't lose access to features. But you can cancel auto-renewal at any time through settings. Access to subscription features will remain until the end of the paid period.",
    },
    TOPIC4: {
      QUESTION: 'Have more questions?',
      ANSWER: 'If you need help, contact our support service.',
      BUTTON: 'Ask a question',
    },
  },
  FAQ_PROFILE: {
    TOPIC1: {
      QUESTION: 'Can I upgrade or downgrade my plan?',
      ANSWER: 'The text will be available shortly. For any inquiries, please contact us by email support@caichat.ai',
    },
    TOPIC2: {
      QUESTION: 'How do i cancel my plan?',
      ANSWER: 'The text will be available shortly. For any inquiries, please contact us by email support@caichat.ai',
    },
    TOPIC3: {
      QUESTION: 'Can i cancel my subscription and still retain plan benefits until the end of the current billing cycle?',
      ANSWER: 'The text will be available shortly. For any inquiries, please contact us by email support@caichat.ai',
    },
    TOPIC4: {
      QUESTION: 'How do i get a refund?',
      ANSWER: 'The text will be available shortly. For any inquiries, please contact us by email support@caichat.ai',
    },
    TOPIC5: {
      QUESTION: 'I have more questions.',
      ANSWER: 'If you need help, click a button down below, feel free to contact our support team.',
      BUTTON: 'Ask a question',
    },
  },
  BACKEND_MESSAGES: {
    INVALID_PASSWORD: 'Invalid password',
    SLUG_ALREADY_TAKEN: 'Slug {{ slug }} is already taken by another user',
    TOKENS_EXCEEDED:
      'Selected model is not available for this character. Free models are blocked for this character. Total context ({{number}} tokens) exceeds limit (5000). Please use a paid model.',
    NOT_ENOUGH_TOKENS: 'You do not have enough tokens to generate this image',
    ALREADY_REPORT_USER: 'You have already reported this user',
    PAYMENT_PROVIDER: {
      NO_PAYMENT_SYSTEMS: 'Payment provider error: No available payment system',
      BETATRANSFER_ERROR: 'Payment provider error: Unknown error from BetaTransfer',
    },
    CANNOT_CREATE_CHAT_WITH_PAID_MODEL:
      'Cannot create chat with paid model. You need tokens or an active paid subscription to use paid models.',
    TRANSACTION_ID_NOT_FOUND: 'Transaction ID {{id}} is not found',
  },
};
